const KByte = 1024;
const MEGA = 1000 * KByte;
const GIGA = 1000 * MEGA;
const TERA = 1000 * GIGA;

export const convertBytesUnitsCbForSaveDivideValue = (bytes: number) => {
    let divideValue: number = KByte;
    let displayUnitMeasurement = 'KB';
    switch (true) {
        case (bytes >= TERA):
            divideValue = TERA;
            displayUnitMeasurement = 'TB';
            break;
        case (bytes < TERA && bytes >= GIGA):
            divideValue = GIGA;
            displayUnitMeasurement = 'GB';
            break;
        case (bytes < GIGA && bytes >= MEGA):
            divideValue = MEGA;
            displayUnitMeasurement = 'MB';
            break;
    }

    return (bytes: number) => ({ value: Number.parseFloat((bytes / divideValue).toFixed(2)), unitName: displayUnitMeasurement});
};

export const convertBytesUnits = (bytes: number): { unitName: string, value: number } => {
    return convertBytesUnitsCbForSaveDivideValue(bytes)(bytes);
};